import { CTAFinancialClarityStyles } from './cta-financial-clarity.style';
import { IconCard, IconCardProps } from '@exploration/shared-components';
import { useForceBreakpoint } from '@exploration/ui-utils';
import { Fragment } from 'react';

const { Section, Container, Title, CTAsContainer, Divider, BoxContainer } =
  CTAFinancialClarityStyles;

export interface CTAFinancialClarityProps {
  headline: string;
  callToAction: IconCardProps[];
}

const CTAFinancialClarity = ({
  headline,
  callToAction,
}: CTAFinancialClarityProps) => {
  const baseDefaultProps = {
    forceMobileBreakpoint: useForceBreakpoint() === 'mobile',
  };
  Container.defaultProps = baseDefaultProps;
  CTAsContainer.defaultProps = baseDefaultProps;
  BoxContainer.defaultProps = baseDefaultProps;
  Divider.defaultProps = baseDefaultProps;

  return (
    <Section>
      <Container>
        <Title as="h2">{headline}</Title>
        <CTAsContainer>
          {callToAction.map((cta, index) => (
            <Fragment key={cta.icon}>
              <BoxContainer>
                <IconCard
                  {...cta}
                  trackingId={`working-with-us-drawer-${cta.text
                    ?.toLocaleLowerCase()
                    .replace(/\s+/g, '-')}`}
                />
              </BoxContainer>
              {index < callToAction.length - 1 && <Divider />}
            </Fragment>
          ))}
        </CTAsContainer>
      </Container>
    </Section>
  );
};

export default CTAFinancialClarity;
